import axios from 'axios'

export default class Classificacao {
  constructor (tokenBearer, url, id) {
    this.url = `${url}/api/unimed/classificacao/${id}`
    this.tokenBearer = tokenBearer
  }

  getClassificacao () {
    return new Promise(async (resolve, reject) => {
      let optionsClassificacao = {
        method: 'get',
        url: this.url,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseClassificacao = await axios(optionsClassificacao)
        resolve(responseClassificacao)
      } catch (err) {
        reject(err)
      }
    })
  }

  putClassificacao (data) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: this.url,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
